import { render } from "./Emailcampaigndetail.vue?vue&type=template&id=d61842c2"
import script from "./Emailcampaigndetail.vue?vue&type=script&lang=js"
export * from "./Emailcampaigndetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__